module.exports = __webpack_public_path__ + "img/feature-image.9850df09.jpg";